const welcome = {
    title: 'Benvenuti alla Console di Amministrazione',
    description: "La console di amministrazione è un'app web per gestire GptHouse senza alcuna conoscenza di programmazione. Iniziamo creando un account. Con questo account, puoi gestire GptHouse da solo o per conto della tua azienda.",
    create_account: 'Crea account',
};
export default Object.freeze(welcome);
